import { testimonialData } from "@/mocks/siteData";

const starIcon = (
  <span className="w-4 h-4 flex items-center justify-center text-secondary-500">
    <i className="ri-star-fill text-sm"></i>
  </span>
);

export default function Testimonials() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
            <span className="text-xs font-semibold uppercase tracking-wider text-secondary-600">
              Community
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Real Reviews<br />From Real Users
          </h2>
          <p className="mt-4 text-sm text-foreground-500 max-w-lg mx-auto">
            Thousands of shoppers trust our superbuy spreadsheet link directory. Here is what the community has to say.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonialData.map((t, index) => (
            <div
              key={index}
              className={`bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 ${
                index === testimonialData.length - 1 ? "opacity-80" : ""
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star}>{starIcon}</span>
                ))}
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                {t.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t.content}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-accent-700">{t.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}